/**
 * Constantes para el módulo de Técnicos
 */

// Estados de México (igual que en Sucursales)
export const ESTADOS_MEXICO = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila de Zaragoza",
  "Colima",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán de Ocampo",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz de Ignacio de la Llave",
  "Yucatán",
  "Zacatecas",
];

export const TECHNICIAN_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ON_LEAVE: "on-leave",
};

export const STATUS_LABELS = {
  [TECHNICIAN_STATUS.ACTIVE]: "Activo",
  [TECHNICIAN_STATUS.INACTIVE]: "Inactivo",
  [TECHNICIAN_STATUS.ON_LEAVE]: "En permiso",
};

/**
 * Genera los campos del formulario para técnicos
 * @param {Array} users - Lista de usuarios disponibles
 */
export const getTechnicianFields = (users = []) => {
  return [
  { name: "name", label: "Nombre" },
  { name: "phone", label: "Teléfono" },
  { name: "assignedVehicle", label: "Vehiculo Asignado" },
  {
    name: "zone",
    label: "Zona (Estado)",
    type: "select",
    helperText: "Solo informativo - Estado de México donde opera el técnico",
    options: [
      { value: "", label: "Sin zona asignada" },
      ...ESTADOS_MEXICO.map((estado) => ({
        value: estado,
        label: estado,
      })),
    ],
  },
  {
    name: "user",
    label: "Usuario del sistema",
    type: "select",
    disabled: true,
    options: users.map((u) => ({
      value: u._id,
      label: `${u.name} (${u.email})`,
    })),
  },
  {
    name: "status",
    label: "Estado",
    type: "select",
    options: [
      { value: TECHNICIAN_STATUS.ACTIVE, label: STATUS_LABELS[TECHNICIAN_STATUS.ACTIVE] },
      { value: TECHNICIAN_STATUS.INACTIVE, label: STATUS_LABELS[TECHNICIAN_STATUS.INACTIVE] },
      { value: TECHNICIAN_STATUS.ON_LEAVE, label: STATUS_LABELS[TECHNICIAN_STATUS.ON_LEAVE] },
    ],
  },
  ];
};

